<script lang="ts">
  import { intersection } from "@opera-gx/common/src/actions/intersection";
  import { type Writable } from "svelte/store";
  import { _ } from "svelte-i18n";
  export let showMore: Writable<boolean>;
  export let showMoreIntersecting: boolean;
  export let section_title: string;
</script>

<style lang="postcss">
  .showMore {
    transition:
      opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1),
      transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
    opacity: 0;
    transform: translateX(-15px);
    will-change: opacity, transform;
    padding: 2px 10px;

    &.show {
      opacity: 1;
      transform: translateX(0);
    }

    &:active {
      transform: scale(1.06);
    }
  }

  .buttonText {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .caret {
    background: theme(colors.accent.DEFAULT);
    mask-image: url("../assets/caret.svg");
    mask-position: center;
    mask-repeat: no-repeat;
    mask-size: 24px;
  }

  .border {
    mask-border-source: url("../assets/border.svg");
    color: theme(colors.accent.DEFAULT);
    background: transparent;
    width: 100%;
    height: 100%;
    position: absolute;
    mask-border-slice: 27 fill;
    mask-border-width: 2rem;
  }
</style>

<div
  class="flex flex-row items-center justify-center gap-2 text-sm font-semibold"
  style="position: relative;">
  <div class="border" />
  <button
    class="showMore flex w-full flex-row items-center justify-center gap-2 text-sm font-semibold"
    class:show={showMoreIntersecting}
    on:click={() => showMore.set(!$showMore)}
    use:intersection={{
      handler: (entries) => {
        if (!entries.some(({ isIntersecting }) => isIntersecting)) {
          showMoreIntersecting = false;
          return;
        }

        if (entries.some(({ intersectionRatio }) => intersectionRatio >= 0.05)) {
          showMoreIntersecting = true;
          return;
        }
      },
      rootMargin: "100% 0px 0px 0px",
      threshold: [0, 0.05],
    }}>
    <div class="caret inline-block h-6 w-6" class:rotate-180={$showMore} />
    <p class="buttonText" style="color: hsl(var(--color-gxm-text-on-wallpaper));">
      {$_($showMore ? "games.show_less" : "games.show_more", {
        values: { section: section_title },
      })}
    </p>
  </button>
</div>
